import { render, staticRenderFns } from "./composeItem.vue?vue&type=template&id=8f99888c&scoped=true&"
import script from "./composeItem.vue?vue&type=script&lang=js&"
export * from "./composeItem.vue?vue&type=script&lang=js&"
import style0 from "./composeItem.vue?vue&type=style&index=0&id=8f99888c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f99888c",
  null
  
)

export default component.exports